/* eslint-disable no-param-reassign */
window.TV2 = window.TV2 || {};

window.TV2.slideBannerCards = (contentbox, statements) => {
  const shuffle = (array) => {
    let currentIndex = array.length;
    let randomIndex;

    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex],
      ];
    }

    return array;
  };

  statements = JSON.parse(statements);

  const banner = document.getElementById(contentbox);
  const cardsElement = banner.querySelector(".partikabal-card__cards");
  const handElement = banner.querySelector(".banner__hand");
  const shuffeledStatements = shuffle(statements);
  const placeholder = { text: "...", color: "#00ABBB" };
  let counter = 0;

  shuffeledStatements.unshift(placeholder);
  shuffeledStatements.push(placeholder);

  cardsElement.innerHTML = shuffeledStatements.reduce(
    (acc, statement) =>
      `${acc} <div class="partikabal-card__card">
                <svg viewBox="0 0 210 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 19.4838C0 8.72319 8.70557 0 19.4444 0H190.556C201.294 0 210 8.7232 210 19.4838V119.593C210 130.354 201.294 139.077 190.556 139.077H19.4444C8.70557 139.077 0 130.354 0 119.593V19.4838Z" fill="black" fill-opacity="0.2"/>
                    <path d="M0 25.2773C0 14.5167 8.70557 5.79352 19.4444 5.79352H190.556C201.294 5.79352 210 14.5167 210 25.2773V113.8C210 124.56 201.294 133 190.556 133H19.4444C8.70557 133 0 124.56 0 113.8V25.2773Z" fill="#C6C6C6"/>
                    <path d="M0 21.4838C0 10.7232 8.70557 2 19.4444 2H190.556C201.294 2 210 10.7232 210 21.4838V111.016C210 121.777 201.294 130 190.556 130H19.4444C8.70557 130 0 121.777 0 111.016V21.4838Z" fill="white"/>
                    <path d="M1.52588e-05 23.3925C1.52588e-05 12.6823 8.70559 4 19.4445 4H190.556C201.294 4 210 12.6823 210 23.3925L210 109.607C210 120.318 201.294 129 190.556 129H19.4444C8.70558 129 0 120.318 0 109.607L1.52588e-05 23.3925Z" fill="#EEEEEE"/>
                    <path fill="${
                      statement.color
                    }" d="M174.92 8L205 38.069V109.966C205 118.269 198.266 125 189.96 125H35.08L5 94.931V23.0345C5 14.7312 11.7336 8 20.04 8H174.92Z" />
                </svg>

                <div class="partikabal-card__statement ${
                  statement.invertColor ? "text-black" : null
                }">${statement.text}</div>
            </div>`,
    ""
  );

  setInterval(() => {
    const scollLength = 230;
    const currentScrollLength = cardsElement.offsetLeft;

    if (counter === statements.length - 3) {
      cardsElement.style.left = `-210px`;
      counter = 0;
    } else {
      cardsElement.style.left = `${currentScrollLength - scollLength}px`;
      counter++;
      handElement.classList.add("swipe");

      setTimeout(() => {
        handElement.classList.remove("swipe");
      }, 2 * 1000);
    }
  }, 15 * 1000);
};

window.TV2.trackVmCards = (contentbox, bannerType) => {
  const banner = document.getElementById(contentbox);

  window.TV2.createObserver(
    banner,
    (entries) => {
      if (entries[0].isIntersecting) {
        // element in viewport
        if (window.dataLayer) {
          window.dataLayer.push({
            event: "interaction",
            eventCategory: "On-Site Interaction",
            eventAction: "Banner - Viewed by user",
            eventLabel: `Banner-${bannerType}`,
          });
        }
      }
    },
    {
      threshold: 1,
    }
  );

  const link = banner.querySelector(".banner__link");
  link.addEventListener("click", function () {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: "interaction",
        eventCategory: "On-Site Interaction",
        eventAction: "Banner - User interaction",
        eventLabel: `Banner-${bannerType}`,
      });
    }
  });
};
